<template>
  <div class="page-wrap">
    <el-breadcrumb separator="/" class="breadcrumb">
		 	<el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item class="linkpath">管理通知人</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
      <section class="content-warpper data-table">
				<!-- 操作行 -->
        <el-row style="margin-bottom:5px;">
					<el-popover
						placement="bottom"
						popper-class="alignCenter"
						width="160"
						trigger="click">
						<el-image :src="wechatUrl"></el-image>
						<el-button  slot="reference" size="small" icon="el-icon-plus" type="primary" @click="newAdd">新增微信通知人</el-button>
					</el-popover>
        </el-row>
				<!-- 表格 -->
        <el-table
					header-row-class-name="data-table-header"
					:data="NotifierList.content"
					tooltip-effect="dark"
					style="width: 100%"
					>
						<el-table-column label="序号" fixed="left" type="index" width="50"></el-table-column>
						<el-table-column label="微信昵称" prop="nickname">
							<template slot-scope="scope">
								<span class="col-img">
									<img :src="scope.row.headimgurl" >{{scope.row.nickname}}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="remark" label="备注">
							<template slot-scope="scope">
								{{scope.row.remark || '--'}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="200" class-name="operate" fixed="right">
              <template slot-scope="scope">
                <span class="op-btn edit" @click="handleEdit(scope.row)"><i class="el-icon-setting"></i> 设置备注</span><span class="verline">&nbsp;|&nbsp;</span>
                <span class="op-btn delete" @click="handleDelete(scope.row)"><i class="el-icon-delete"></i>删除</span>
              </template>
            </el-table-column>
				</el-table>
				<Pagination
					v-if="NotifierList.totalElements"
					class="pagination"
					:total="NotifierList.totalElements"
					:pagination="pagination"
					@onChange="load"/>
      </section>
			<!-- 编辑备注人 -->
			<el-dialog title="填写备注" :visible.sync="modalInfo.isShow" v-if="modalInfo.isShow" width="30%">
				<el-form :model="modalInfo.form" label-position="right"  label-width="50px">
					<el-form-item label="备注" prop="remark">
						<el-input v-model.trim="modalInfo.form.remark" size="small"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
					<el-button size="small" class="cancel" @click="modalInfo.isShow = false">取 消</el-button>
				</div>
  		</el-dialog>
    </div>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/pagination';
import {renderDialog } from "@/libs/renderCommon.js"
import { fetchGet,fetchPost } from "@/libs/reqCommon";
import {mapState,mapActions} from 'vuex';
import wxBindingComponent from "../../../components/wxComponent/wxBindingComponent.vue";

export default {
  components:{Pagination,wxBindingComponent},
  data() {
    return {
			NotifierList:{
				content:[{}]
			},
			wechatUrl:'',
			pagination: {
					size: 10,
					current: 1
			},
			modalInfo:{
				isShow:false,
				form:{}
			}
    };
	},
	computed:{
		...mapState({
			userInfo: state => state.serviceReport.userinfo,
		}),
  },
  created() {
		this.reqGetbmcwx(); //获取当前用户的信息
	  this.load();
  },
  methods: {
		reqNotifierList(query){
			fetchGet('/hcm/hcmNewMonitorProduct/monitorNoticeList', query).then(res => {
				if(res.status == '10000'){
					this.NotifierList.content = res.data;
					this.NotifierList.totalElements = res.data.length;
				}else{
					this.$message.error(res.message);
				}
			})
		},
		getParams() {
			let params = {
				pageNo: this.pagination.current,
				pageSize: this.pagination.size
			}
			return params;
		},
		load() {
			let params = this.getParams();
			this.reqNotifierList(params);
		},
		// 编辑备注
		handleEdit(row){
			this.modalInfo.isShow = true;
			this.modalInfo.form = {
				id:row.id,
				remark:row.remark
			}
		},
		// 删除请求
    reqDelete(query,url){
      fetchGet(url, query).then(res => {
        if(res.status == '10000'){
          this.$message({
            message: '操作成功！',
            type: res.message
          })
          this.load();
        }else{
          this.$message.error(res.message);
        }
      })
		},
		...mapActions(['reqGetbmcwx']),
		// 新增(扫码绑定)
		newAdd(){
      this.$refs.childWxBinding.getbmcwx('m',this.userInfo.bid,this.userInfo.openid)
		},
		//删除
		handleDelete(row){
			let query = {
				id:row.id
			}
      let url = "hcm/hcmNewMonitorProduct/deleteMonitorNoticeList"
      let func = this.reqDelete
      let info = {
        title:`你确认要删除该通知人吗?`,
        infoccc:'删除后',infored:`该通知人信息将无法恢复`
      }
      renderDialog(info,url,query,func,this)
		},
		//编辑
		confirmClick(){
			fetchGet('hcm/hcmNewMonitorProduct/setUpMonitorRemark', this.modalInfo.form).then(res => {
        if(res.status == '10000'){
          this.$message({
            message: '操作成功！',
            type: res.message
          })
					this.load();
					this.modalInfo.isShow = false;
        }else{
          this.$message.error(res.message);
        }
      })
		}
  }
};
</script>

<style lang="scss">

@import "src/style/dataTable";
$highColor:#108cee;
.alignCenter {
	text-align: center;
}

.el-table__body tr.hover-row{
    cursor: default !important;
}
.data-table .el-table .cell {
	.col-img img{
		width: 40px;
    vertical-align: middle;
		margin-right: 10px;
	}
}
.pagination{
	text-align: right;
  margin: 10px 0;
}
</style>
